import * as React from 'react'
import { DisplayContent, Plural, Singular } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'

import { AppState } from '../../../data/state'

interface BabyCribSummaryProps {
  numberOfBabies: number
  babyCrib: boolean
}

const BabyCribSummary: React.FC<BabyCribSummaryProps> = ({
  numberOfBabies,
  babyCrib,
}) => {
  return (
    <>
      {numberOfBabies > 0 && babyCrib ? (
        <ListItem>
          <DisplayContent
            addNode
            contentKey="baby-crib-summary"
            plural={numberOfBabies > 1}
          >
            <Singular>A crib for your baby</Singular>
            <Plural>A crib for your baby(s)</Plural>
          </DisplayContent>
        </ListItem>
      ) : null}
    </>
  )
}

export default connect((state: AppState) => ({
  numberOfBabies: state.funnelOrder.numberOfBabies,
  babyCrib: state.funnelOrder.babyCrib,
}))(BabyCribSummary)
